import { FOOTER_MJML } from "../common/footer";
import { TRANSACTIONAL_HEADER } from "../common/header";

export const confirmation = `
<mjml>
  <mj-head>
    <mj-title>Order Confirmation</mj-title>
    <mj-preview>Your order has been processed</mj-preview>
    <mj-attributes>
      <mj-all font-family="Arial, sans-serif" />
      <mj-text font-size="16px" color="#333333" line-height="1.5" />
    </mj-attributes>
  </mj-head>
  <mj-body>
    ${TRANSACTIONAL_HEADER(
      "Order Confirmation",
      "Thank you for your purchase!"
    )}
    
    <mj-section background-color="#ffffff" padding="30px 0">
      <mj-column>
        <mj-text font-size="22px" color="#333333" font-family="Arial, sans-serif">Hello {{first_name}},</mj-text>
        <mj-text font-size="16px" color="#555555" font-family="Arial, sans-serif">Thank you for your order. We're pleased to confirm that we've received your order and it's being processed. Here's a summary of your purchase:</mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 0 20px">
      <mj-column>
        <mj-table>
          <tr style="border-bottom: 1px solid #ecedee; text-align: left;">
            <th style="padding: 0 15px 10px 0;">Order Number</th>
            <td style="padding: 0 0 10px 0;">#ORD-123456</td>
          </tr>
          <tr style="border-bottom: 1px solid #ecedee; text-align: left;">
            <th style="padding: 10px 15px 10px 0;">Order Date</th>
            <td style="padding: 10px 0 10px 0;">October 1, 2023</td>
          </tr>
          <tr style="border-bottom: 1px solid #ecedee; text-align: left;">
            <th style="padding: 10px 15px 10px 0;">Payment Method</th>
            <td style="padding: 10px 0 10px 0;">Credit Card (ending in 1234)</td>
          </tr>
        </mj-table>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#ffffff" padding="0 0 20px">
      <mj-column>
        <mj-text font-size="20px" color="#333333" font-weight="bold">Order Summary</mj-text>
        <mj-table>
          <tr style="border-bottom: 1px solid #ecedee; text-align: left; font-weight: bold;">
            <th style="padding: 0 15px 10px 0;">Product</th>
            <th style="padding: 0 15px 10px 0;">Quantity</th>
            <th style="padding: 0 0 10px 0;">Price</th>
          </tr>
          <tr style="border-bottom: 1px solid #ecedee; text-align: left;">
            <td style="padding: 10px 15px 10px 0;">Product Name 1</td>
            <td style="padding: 10px 15px 10px 0;">1</td>
            <td style="padding: 10px 0 10px 0;">$99.99</td>
          </tr>
          <tr style="border-bottom: 1px solid #ecedee; text-align: left;">
            <td style="padding: 10px 15px 10px 0;">Product Name 2</td>
            <td style="padding: 10px 15px 10px 0;">2</td>
            <td style="padding: 10px 0 10px 0;">$49.99</td>
          </tr>
          <tr style="text-align: left; font-weight: bold;">
            <td style="padding: 10px 15px 10px 0;" colspan="2">Total</td>
            <td style="padding: 10px 0 10px 0;">$199.97</td>
          </tr>
        </mj-table>
      </mj-column>
    </mj-section>
    
    <mj-section background-color="#f8f9fa" padding="20px">
      <mj-column>
        <mj-text font-size="20px" font-weight="bold" align="center">Track your order</mj-text>
        <mj-button background-color="#faad14" color="#ffffff" font-family="Arial, sans-serif" href="#" width="200px" border-radius="4px">Track Order</mj-button>
      </mj-column>
    </mj-section>
    
    ${FOOTER_MJML}
  </mj-body>
</mjml>
`;

// Template metadata for the gallery
export default {
  id: "confirmation",
  name: "Order Confirmation",
  category: "transactional",
  purpose: "transactional" as const,
  description:
    "A clean, detailed order confirmation email that clearly presents order information and next steps for customers.",
  features: [
    "Order number and date",
    "Itemized order summary",
    "Total amount",
    "Support contact information",
    "Order tracking",
  ],
  subject: "Order Confirmation",
  subTitle: "Your order has been processed",
  mjmlTemplate: confirmation,
  tags: ["transactional", "order", "confirmation", "receipt"],
};
